'use strict';

angular.module('mediacloudApp', ['LocalStorageModule', 'tmh.dynamicLocale', 'pascalprecht.translate',
    'ngResource', 'ui.router', 'ui.router.state.events', 'ngCookies', 'ngAria', 'ngCacheBuster', 'infinite-scroll', 'angularFileUpload', 'nvd3', 'daterangepicker',
    'angularUtils.directives.dirPagination', 'ui.select', 'ngSanitize', 'ngCsv', 'ngDialog', 'ngAnimate', 'ui.bootstrap', 'frapontillo.bootstrap-switch',
    'angular.atmosphere', 'ui.bootstrap-slider', 'angular-toArrayFilter', 'ngclipboard', 'vsdropdown'])

    .run(function ($rootScope, $location, $window, $anchorScroll, $http, $state, $translate, atmosphereService, Language, Auth, Principal, FileUploader, ENV, VERSION, localStorageService, Tenant) {
        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'

        Tenant.info().then(function (tenant) {
            $rootScope.tenant = tenant;
            if (tenant.primaryColor != "") {
                var css = "<style type='text/css'>#header { background-color: " + tenant.primaryColor + " !important; }";
                css += "#header .navbar .dropdown.open a { background: " + tenant.primaryBackgroundColor + "; color: " + tenant.secondaryColor + " !important; }";
                css += "#header .navbar ul.nav > li > a:hover { background: " + tenant.primaryBackgroundColor + " !important; }";
                css += "#mast-container .page-heading h1:before { background: " + tenant.primaryColor + " !important; }";
                css += "#header .navbar ul.nav > li > a:focus { background: " + tenant.primaryBackgroundColor + "!important; }";
                css += "#header .navbar .dropdown.open a, #header .navbar .dropdown.open a.active, #header .navbar .dropdown.open:hover a, #header .navbar .dropdown.open:hover a.active { background: none; }";
                css += "#header .navbar { border-color: " + tenant.secondaryBackgroundColor + "; }";
                css += "#header .navbar ul.nav > li > a { border-color: " + tenant.secondaryBackgroundColor + "; }";
                css += ".course-breadcrumb-text { color: " + tenant.primaryBackgroundColor + "; }";
                css += ".fa {color: " + tenant.secondaryBackgroundColor + " !important;}";
                css += ".btn:not(.media-opt) { background: " + tenant.primaryBackgroundColor + " !important; color: " + tenant.secondaryColor + " !important; border-color: " + tenant.secondaryColor + " !important}";
                css += ".container .fa {color: " + tenant.primaryBackgroundColor + " !important;}";
                css += ".btn i {color: " + tenant.secondaryColor + " !important;}";
                css += ".btn-link-secondary:not(.media-opt) { background: " + tenant.secondaryBackgroundColor + " !important; color: " + tenant.primaryBackgroundColor + " !important; border-color: " + tenant.primaryBackgroundColor + " !important}";
                css += ".btn-link-secondary i { color: " + tenant.primaryBackgroundColor + " !important; }";
                css += ".btn-link-secondary svg path { fill: " + tenant.primaryBackgroundColor + " !important; }";
                css += ".fa-sign-out { color: " + tenant.primaryBackgroundColor + " !important; }";
                css += ".fa-sign-in { color: " + tenant.primaryBackgroundColor + " !important; }";
                css += ".icons .fa { color: " + tenant.primaryBackgroundColor + " !important; }";
                css += ".fa-times { color: " + tenant.primaryBackgroundColor + " !important; }";
                css += ".pageBtn { background: " + tenant.primaryBackgroundColor + " !important; color: " + tenant.secondaryColor + " !important; border-color: " + tenant.secondaryColor + " !important}";
                css += ".addanevent { background: " + tenant.primaryBackgroundColor + " !important; color: " + tenant.secondaryColor + " !important; border-color: " + tenant.secondaryColor + " !important}";
                css += ".pageBtn i {color: " + tenant.secondaryColor + " !important;}";
                css += ".addanevent span {color: " + tenant.secondaryColor + " !important;}";
                css += "#cancelBtn { background: " + tenant.secondaryBackgroundColor + " !important; color: " + tenant.primaryBackgroundColor + " !important; border-color: " + tenant.primaryBackgroundColor + " !important}";
                css += "#cancelRecordingBtn { background: " + tenant.secondaryBackgroundColor + " !important; color: " + tenant.primaryBackgroundColor + " !important; border-color: " + tenant.primaryBackgroundColor + " !important}";
                css += "#cancelBtn i { color: " + tenant.primaryBackgroundColor + " !important; }";
                css += "#cancelRecordingBtn i { color: " + tenant.primaryBackgroundColor + " !important; }";
                css += "#header .navbar ul.nav > li:focus { background: " + tenant.primaryBackgroundColor + ";}";
                css += "#header .navbar .dropdown.open .dropdown-menu { background: " + tenant.primaryBackgroundColor + ";}";
                css += "#header .navbar ul.nav > li > a i { color: " + tenant.secondaryBackgroundColor + "; }";
                css += "#header a { color: " + tenant.secondaryColor + " !important; }";
                css += "a {color: " + tenant.primaryColor + " !important; }";
                css += "#main-container {background: " + tenant.primaryBackgroundColor + "; }";
                css += "#header .navbar { background-color: " + tenant.primaryColor + " !important; }";
                css += ".progress-bar { background-color: " + tenant.primaryColor + " !important; }";
                css += ".btn.fileUpload { background-color: #fff !important; color: #bbb !important; }";
                css += ".batch-section { border-color: " + tenant.secondaryBackgroundColor + " !important; }";
                css += ".collection .course-header { background-color: " + tenant.primaryColor + " !important; }";
                css += "#footer { background-color: " + tenant.primaryColor + " !important; }";
                css += "div:focus { outline: solid " + tenant.primaryBackgroundColor + " !important; }";
                css += ".collection .navbar .navbar-nav > .activeitem { border-bottom: 5px solid " + tenant.primaryColor + " !important; }";
                css += ".img-responsive { width: " + tenant.headerWidth + "; }";
                css += ".footer-logo { top:15px; width: " + tenant.footerWidth + " !important; height: " + tenant.footerHeight + " !important; }";
                css += ".redesign.select { color: #2380be !important; }";
                css += "</style>";
                $(css).appendTo('head');
                var favicon = "<link rel='shortcut icon' type='image/png' href=" + tenant.favicon + ">";
                $(favicon).appendTo('head');
            }
            var newCss = "<style>#course_channels_carousel .carousel-caption { background: none !important; }";
            newCss += ".carousel-control .fa { top: 40%;position: relative;font-size: xx-large; }";
            newCss += "#course_channels_carousel .carousel-caption .text a {color: #fff !important; background: black;}";
            newCss += ".carousel-inner>.item>img { height: inherit !important; }";
            newCss += "#course_channels_carousel .carousel-caption .text {    width: 20ch;    position: absolute;    bottom: 40px;    left: 115px;    box-shadow: black 10px 30px 240px 410px;}";
            newCss += "#course_channels_carousel .carousel-caption .text a {    color: #fff !important;    font-weight: bold;}";
            newCss += ".main-carousel>.carousel-inner>.item {    background: black;    height: 300px;    overflow: hidden;    cursor: pointer;}";
            newCss += ".carousel-inner>.item>img {    display: block;    max-width: 100%; width: 50% !important;   height: 100% !important;    line-height: 1;    float: right;}";
            newCss += "</style>";
            $(newCss).appendTo('head');
        });

        var updateTitle = function(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        };

        var updateAuthHeader = function(authToken){
            $http.defaults.headers.common['x-auth-token']=authToken;
        };

        if(localStorageService.get("authToken")){
            $http.defaults.headers.common['x-auth-token'] = localStorageService.get("authToken");
        }

        // unsubscribes from all atmosphere endpoints on page refresh
        atmosphereService.unsubscribe();

        // unsubscribes from all atmosphere endpoints when closing the browser window/tab
        $window.onbeforeunload = function(){
            atmosphereService.unsubscribe();
        };

        $rootScope.ENV = ENV;
        $rootScope.VERSION = VERSION;
        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromParams) {
            $rootScope.toState = toState;
            $rootScope.toStateParams = toStateParams;
            $rootScope.previousStateName = fromState.name;
            $rootScope.previousStateParams = fromParams;

            if(toStateParams.authToken){
                updateAuthHeader(toStateParams.authToken);
                $rootScope.AUTHTOKEN=toStateParams.authToken;
            }

            if (Principal.isIdentityResolved()) {
                Auth.authorize();
            }

            // Update the language
            Language.getCurrent().then(function (language) {
                $translate.use(language);
            });

            // unsubscribes from all atmosphere endpoints while changing between states
            // this is fine as long as we do not share an atmosphere connection between states in the application
            atmosphereService.unsubscribe();

        });

        $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
            var titleKey = 'global.title' ;

            // Remember previous state unless we've been redirected to login or we've just
            // reset the state memory after logout. If we're redirected to login, our
            // previousState is already set in the authExpiredInterceptor. If we're going
            // to login directly, we don't want to be sent to some previous state anyway
            if (toState.name != 'login' && $rootScope.previousStateName) {
              $rootScope.previousStateName = fromState.name;
              $rootScope.previousStateParams = fromParams;
            }

            // Set the page title key to the one configured in state or use default one
            if (toState.data.pageTitle) {
                titleKey = toState.data.pageTitle;
            }
            updateTitle(titleKey);

            $anchorScroll();
        });

        $rootScope.scrollTo = function(id) {
            $anchorScroll(id);
        };

        // if the current translation changes, update the window title
       /* $rootScope.$on('$translateChangeSuccess', function() { updateTitle(); });*/


        $rootScope.back = function() {
            // If previous state is 'activate', 'finishReset', or do not exist go to 'home'
            if ($rootScope.previousStateName === 'activate' || $rootScope.previousStateName === 'finishReset' || $state.get($rootScope.previousStateName) === null || $rootScope.previousStateName === '') {
                $state.go('home');
            } else {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
            }
        };

        // If the current state's name begins with lms, then it is an lms page
        if($location.url().indexOf("/lms") === 0){
            $rootScope.hideHeaderAndFooter = true;
            $rootScope.lmsCSS = true;
        }

        // This will ensure that upload still works if you select the same file to upload after cancelling a previous upload
        FileUploader.FileSelect.prototype.isEmptyAfterSelection = function() {
            return true;
        };

        String.prototype.formatMessage = String.prototype.formatMessage ||
        function () {
            "use strict";
            var str = this.toString();
            if (arguments.length) {
                var t = typeof arguments[0],
                    key,
                    args = ("string" === t || "number" === t) ? Array.prototype.slice.call(arguments) : arguments[0];
                for (key in args) {
                    str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
                }
            }
            return str;
        };

        $("#mainBody").show();

        // For Accessible outlines - blue border is shown only on keyboard focus rather than click
        smartOutline.init();
    })
    .constant('UploadErrors', {
        GET_PREV_BATCHES: "Error Code: 100 - An error occurred while loading previously uploaded batches.",
        GET_PREV_FILE_THUMBS: "Error Code: 101 - An error occurred while loading thumbnails for this file.",
        CREATE_BATCH: "Error Code: 102 - An error occurred while creating a batch for grouping uploads.",
        CREATE_BASEFILE: "Error Code: 103 - An error occurred while uploading the file \"{name}\".",
        GET_UPLOAD_TOKEN: "Error Code: 104 - An error occurred while retrieving the upload token for the file \"{name}\".",
        UPLOAD_FILE: "Error Code: 105 - An error occurred while uploading the file \"{name}\".",
        UPDATE_BASEFILE: "Error Code: 106 - An error occurred while saving the File ID for the file \"{name}\".",
        CREATE_JOB: "Error Code: 107 - An error occurred while creating a job for the file \"{name}\".",
        UPDATE_BATCH_METADATA: "Error Code: 108 - An error occurred while applying changes to the metadata for this batch.",
        SEND_BATCH_CAPTION: "Error Code: 109 - An error occurred while sending this batch for captioning.",
        UPDATE_FILE_METADATA: "Error Code: 110 - An error occurred while applying changes to the metadata for this file.",
        SEND_FILE_CAPTION: "Error Code: 111 - An error occurred while sending this file for captioning.",
        CHOOSE_THUMBNAIL: "Error Code: 112 - An error occurred while saving the thumbnail for this file.",
        CANCEL_BATCH: "Error Code: 113 - An error occurred while cancelling this batch.",
        CANCEL_FILE: "Error Code: 114 - An error occurred while cancelling this file.",
        GET_PROFILES: "Error Code: 115 - An error occurred while fetching profiles.",
        CREATE_PROFILE: "Error Code: 116 - An error occurred while creating the profile.",
        PUBLISH_FILE: "Error Code: 117 - An error occurred while publishing the asset with title \"{name}\".",
        PUBLISH_BATCH: "Error Code: 118 - An error occurred while publishing this batch.",
        TRANSCODE: "Error Code: 119 - A fatal error occurred while transcoding a file in this batch.",
        SEND_USER_NOTIFICATION: "Error Code: 121 - An error occurred while saving the user notification choice.",
        EMBED: "Error Code: 123 - An error occurred while adding the file.",
        UPLOAD_FILE_TYPE: "Error Code: 124 - The file \"{name}\" has an unsupported file extension and cannot be uploaded.",
        UPLOAD_FILE_SIZE: "Error Code: 125 - The file \"{name}\" exceeds the maximum supported size for file uploads. Please upload a file less than 8 GB.",
        UPLOAD_QUEUE_SIZE: "Error Code: 126 - The file \"{name}\" was not added to the batch because only {size} files can be uploaded as part of a single batch. Please add the file as part of a new batch.",
        WATSON_LIMIT_REACHED: "Error Code: 127 - File cannot be sent for captioning, as its size is greater than the maximum supported file size."
    })
    .constant('UploadLimits', {
        FILE_SIZE: 8589934592,
        QUEUE_SIZE: 10,
        ACCEPTED_FILE_TYPES: ["mp4", "m4v", "m4a", "mp3", "flv", "f4v", "f4a", "mpeg", "mpg", "avi", "mov", "asf", "ts", "ogg", "ogv", "webm", "wmv", "wav", "aiff", "aif", "wma", "swf", "zip", "jpeg", "jpg", "png"],
        NO_TRANSCODE_FILE_TYPES: ["swf", "zip", "jpeg", "jpg", "png"]
    })
    .constant('CaptionTypeMessages', {
        EMBEDDED: "This file was not sent to Watson, as ShareStream extracted embedded captions from the file's metadata.",
        WATSON: "This file has been sent for captioning. When captions for the file are available, a \"(CC)\" indicator will appear next to the asset's Title in MediaManager."
    })
    .config(function ($stateProvider, $urlRouterProvider, $httpProvider, $locationProvider, $translateProvider, $sceDelegateProvider, tmhDynamicLocaleProvider, httpRequestInterceptorCacheBusterProvider, AlertServiceProvider, paginationTemplateProvider) {
        // uncomment below to make alerts look like toast
        //AlertServiceProvider.showAsToast(true);

        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');
        $stateProvider.state('site', {
            'abstract': true,
            views: {
                'header@': {
                    templateUrl: 'scripts/components/header/header.html',
                    controller: 'HeaderController'
                },
                'footer@': {
                    templateUrl: 'scripts/components/footer/footer.html',
                    controller: 'FooterController'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });

        //remove the bang in the URLs
        //$locationProvider.html5Mode(true);
        $locationProvider.hashPrefix('');

        //$httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
       // $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application interceptor here

        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/en/{part}.json'
            //urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useCookieStorage();
        $translateProvider.useSanitizeValueStrategy('escaped');
        /*$translateProvider.addInterpolation('$translateMessageFormatInterpolation');*/

        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading Media Manager inside iframe
            '**'
        ]);

        tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        //tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');

        paginationTemplateProvider.setPath('scripts/components/accessible-pagination/dirPagination.html');

        // Used in Scheduler
        Date.prototype.addHours = function(h) {
            var dt = new Date();
            dt.setTime(this.getTime() + (h*60*60*1000));
            return dt;
        };
        Date.prototype.clearSeconds = function() {
            this.setSeconds(0);
            this.setMilliseconds(0);
            return this;
        };
    })
    // jhipster-needle-angularjs-add-config JHipster will add new application configuration here
    .config(['$urlMatcherFactoryProvider', function($urlMatcherFactory) {
        $urlMatcherFactory.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val == true ? true : val == "true" ? true : false },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0 },
            pattern: /bool|true|0|1/
        });
    }
    ])
;
